import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';

import { buttonsReset } from 'src/store/modules/buttons';
import { editTextReset } from 'src/store/modules/editText';
import { imageReset } from 'src/store/modules/imageUpload';
import { pagesReset } from 'src/store/modules/pages';

import setInitValue from 'src/utils/setInitValue';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';
import { switchReset } from 'src/store/modules/switchButton';
import { initTrackingValues } from '../TemplateTracking/BasicFullImageTracking';

const initViewValues = {
  switchMediaType: 'image',
  bgImage: {
    background:
      'https://image.inappmessage.com/sample/fullcardslide-image01.png'
  },
  bgVideo: {
    background: ''
  },
  deeplink: { background: 'https://www.inappmessage.com/' },

  text: { title: 'iam Template E-Commerce', sub_title: 'LOGO' },
  fontSize: { title: 18, sub_title: 14 },
  fontWeight: { title: 600, sub_title: 600 },
  color: { title: '#ffffff', sub_title: '#999999' },
  fontFamily: { title: 'Montserrat', sub_title: 'Montserrat' },
  textAlign: { title: 'center', sub_title: 'center' },

  btnText: { left_button: "Don't ask again", right_button: 'Close' },
  btnFontSize: { left_button: 0.75, right_button: 0.75 },
  btnFontWeight: { left_button: 600, right_button: 600 },
  btnColor: { left_button: '#000000', right_button: '#000000' },
  btnBgColorR: { left_button: 255, right_button: 255 },
  btnBgColorG: { left_button: 255, right_button: 255 },
  btnBgColorB: { left_button: 255, right_button: 255 },
  btnBgColorA: { left_button: 1, right_button: 1 },
  btnFontFamily: { left_button: 'Montserrat', right_button: 'Montserrat' },
  btnAgain: {
    type: 'none',
    left_button: "don't show"
  }
};

const BasicFullImage: FC = () => {
  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState('');

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        setCurrentUser(current.attributes['custom:Company']);
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgVideo = useSelector((state: RootState) => state.imageUpload.bgVideo);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const switchMediaType = useSelector(
    (state: RootState) => state.switchButton.switchMediaType
  );

  const btnFontLeftURL = getFontURL(btnFontFamily?.left_button);
  const btnFontRightURL = getFontURL(btnFontFamily?.right_button);

  const style = `
  @font-face {
    font-family: 'btnFontLeft';
    src: url(${btnFontLeftURL});
  }

  @font-face {
    font-family: 'btnFontRight';
    src: url(${btnFontRightURL});
  }
  .root_view {   
    width: 100%;
    height: 100%;  
    position: relative;
    

    
    .modal_wrapper {
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding-bottom: 72px;
      background-color: #000000;
    }
    .modal_wrapper .inapp_video {
      width: 100%;
      height: 100%;
      object-fit: contain;      
      object-position: center;
    }

    .modal_wrapper img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: bottom;
    }
  
    .bottom_btn {
      width: 100%;
      height: 4.5rem;
      padding: 1rem 2.25rem;
      padding-bottom: 1.5rem;

      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;

      position: absolute;
      bottom: 0;
      background-color:rgba(${btnBgColorR?.left_button},${
    btnBgColorG?.left_button
  }, ${btnBgColorB?.left_button}, ${btnBgColorA?.left_button});
    }

    .bottom_btn button {
      border: 0;
      letter-spacing: 0.0225rem;
      
    }

    .bottom_btn .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: left;
      font-size: ${btnFontSize?.left_button}rem;
      font-weight: ${btnFontWeight?.left_button};
      color: ${btnColor?.left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.left_button
        )
          ? btnFontFamily?.left_button
          : 'btnFontLeft'
      };
      background-color: transparent;
      
    }
  
    .bottom_btn .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      text-align: right;
      font-size: ${btnFontSize?.right_button}rem;
      font-weight: ${btnFontWeight?.right_button};
      color: ${btnColor?.right_button};

      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.right_button
        )
          ? btnFontFamily?.right_button
          : 'btnFontRight'
      };
      background-color: transparent;      
    }
  }
  `;

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(trackingReset());
      dispatch(switchReset());
    };
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view">
        <div className="modal_wrapper">
          {switchMediaType === 'image' ? (
            <img src={bgImage?.background} alt="bgImage" />
          ) : (
            <video
              key={bgVideo?.background}
              className="inapp_video"
              autoPlay
              muted
              playsInline
              loop
              width="100%"
              height="100%"
            >
              <source src={bgVideo?.background} />
            </video>
          )}
        </div>

        <div className="bottom_btn">
          <button className="style01">{btnText?.left_button}</button>
          <button className="style02">{btnText?.right_button}</button>
        </div>
      </div>
    </>
  );
};
export default BasicFullImage;
